import { Component, OnInit } from '@angular/core';
import { ThemeService } from 'src/app/services/base/theme.service';

@Component({
  selector: 'app-ribbon-edit',
  templateUrl: './ribbon-edit.component.html',
  styleUrls: ['./ribbon-edit.component.scss']
})
export class RibbonEditComponent implements OnInit {

  constructor(public theme:ThemeService) { }

  ngOnInit(): void {
  }

}
